import { ReactNode } from 'react';
import { ArcadeStoreHeader } from './ArcadeStoreHeader';
import { Body } from './Body';
import { FileRouteTypes } from '@tanstack/react-router';

type PageProps = {
  children: ReactNode;
  title?: string;
  showHeader?: boolean;
  showFooter?: boolean;
  backRoute?: FileRouteTypes['to'];
  onBack?: () => void;
  rightElement?: ReactNode;
  showAccountAndBalance?: boolean;
};

export const Page = ({
  children,
  title,
  showFooter = true,
  backRoute,
  onBack,
  rightElement,
  showAccountAndBalance = true,
}: PageProps) => {
  return (
    <div className={`flex h-dvh min-h-dvh flex-col overflow-y-scroll pb-safe`}>
      <ArcadeStoreHeader
        title={title}
        backRoute={backRoute}
        onBack={onBack}
        rightElement={rightElement}
        showAccountAndBalance={showAccountAndBalance}
      />
      <Body showFooter={showFooter}>{children}</Body>
    </div>
  );
};
